@if (showIndicator()) {
    <i class="linear-bet-builder-pick-display-header__warning theme-warning"></i>
}
